module.exports = __webpack_public_path__ + "./fonts/facebooklogo.4482c462e2211bafec5dbdd2216912ed.svg";